export const LANGUAGE_LABELS: { [key in Language]: string } = {
  ar: 'languages.ar',
  'ar-IL': 'languages.ar-IL',
  az: 'languages.az',
  cs: 'languages.cs',
  da: 'languages.da',
  de: 'languages.de',
  ee: 'languages.ee',
  el: 'languages.el',
  en: 'languages.en',
  et: 'languages.et',
  fi: 'languages.fi',
  fr: 'languages.fr',
  he: 'languages.he',
  hr: 'languages.hr',
  hu: 'languages.hu',
  is: 'languages.is',
  ja: 'languages.ja',
  ka: 'languages.ka',
  lt: 'languages.lt',
  lv: 'languages.lv',
  nb: 'languages.nb',
  pl: 'languages.pl',
  ru: 'languages.ru',
  sk: 'languages.sk',
  sl: 'languages.sl',
  sq: 'languages.sq',
  sr: 'languages.sr',
  sv: 'languages.sv',
  uz: 'languages.uz',
};
